<div class="flex flex-col gap-5 rounded-2xl border border-gray-100 bg-white p-6 shadow-sm">
  <div class="flex flex-col gap-3">
    <h3 class="text-primary text-sm font-bold">
      {{ editData() ? "Edit Attribute" : "Define Attributes" }}
    </h3>
  </div>
  <hr class="border-gray-100" />
  <div class="flex flex-col gap-6">
    <div class="grid grid-cols-1 gap-4 md:grid-cols-2">
      <div class="flex flex-col gap-1.5">
        <label class="text-sm font-bold text-gray-700">Attribute Title (English)</label>
        <input
          type="text"
          [ngModel]="newAttributeKeyEn()"
          (ngModelChange)="newAttributeKeyEn.set($event)"
          (blur)="enTouched.set(true)"
          placeholder="Enter title (EN, optional)"
          class="focus-border-primary w-full rounded-xl border border-gray-200 p-3 text-sm outline-none"
          [class.border-red-400]="enTouched() && (enErrors().maxlength || enErrors().englishOnly)" />
        @if (enTouched()) {
          @if (enErrors().maxlength) {
            <span class="text-xs font-medium text-red-500" i18n="@@value.validation.maxLength">
              Maximum 100 characters allowed
            </span>
          } @else if (enErrors().englishOnly) {
            <span class="text-xs font-medium text-red-500" i18n="@@attr.validation.onlyEnglish">
              Please enter English characters only
            </span>
          }
        }
      </div>
      <div class="flex flex-col gap-1.5">
        <label class="text-sm font-bold text-gray-700">
          Attribute Title (Arabic)
          <span class="text-red-500">*</span>
        </label>
        <input
          type="text"
          [ngModel]="newAttributeKeyAr()"
          (ngModelChange)="newAttributeKeyAr.set($event)"
          (blur)="arTouched.set(true)"
          placeholder="Enter title (AR)"
          class="focus-border-primary w-full rounded-xl border border-gray-200 p-3 text-sm outline-none"
          [class.border-red-400]="arTouched() && (arErrors().required || arErrors().maxlength || arErrors().arabicOnly)" />
        @if (arTouched()) {
          @if (arErrors().required) {
            <span class="text-xs font-medium text-red-500" i18n="@@attr.validation.titleArRequired">
              Arabic attribute title is required
            </span>
          } @else if (arErrors().maxlength) {
            <span class="text-xs font-medium text-red-500" i18n="@@value.validation.maxLength">
              Maximum 100 characters allowed
            </span>
          } @else if (arErrors().arabicOnly) {
            <span class="text-xs font-medium text-red-500" i18n="@@attr.validation.onlyArabic">
              Please enter Arabic characters only
            </span>
          }
        }
      </div>
    </div>

    <div class="flex justify-end gap-3">
      <button (click)="goBack()" class="rounded-xl border border-gray-200 px-6 py-2.5 text-sm font-bold text-gray-500">
        Cancel
      </button>
      <button
        (click)="submitForm()"
        [disabled]="isInvalid() || isSaving()"
        class="bg-primary rounded-xl px-8 py-2.5 text-sm font-bold text-white shadow-md disabled:opacity-50">
        {{ editData() ? "Save Changes" : "+ Add Attribute" }}
      </button>
    </div>
  </div>
</div>
